import { useEffect } from 'react'
import { ArticleItem } from './ArticleItem'
import { useFieldArray, useFormContext } from 'react-hook-form'

export function ArticleSectionsList({ articles }) {
  const { control, setValue } = useFormContext()

  console.log('articles', articles?.secoes)

  const { fields } = useFieldArray({
    control,
    name: 'secoes',
  })

  console.log('fields', fields)

  useEffect(() => {
    setValue('secoes', articles?.secoes)
  }, [articles, setValue])

  return fields.map((section, index) => <ArticleItem key={section.id} control={control} article={section} index={index} />)
}
